import URLS from './modules/urls';
import { LANGUAGE_LIST, LANGUAGE_LOCALE_MAPPING } from './modules/language-list';

const LOGIN_EXPIRES = 5; // 天
const GOOGLE_CLIENT_ID = '218176000775-pcmibgh0cj18amqf0gkcgqncqqtrv51l.apps.googleusercontent.com';

export { URLS, LOGIN_EXPIRES, LANGUAGE_LIST, LANGUAGE_LOCALE_MAPPING, GOOGLE_CLIENT_ID };
